module.exports = __webpack_public_path__ + "static/img/4.e8f6dfe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/4.jpg
// module id = qNNl
// module chunks = 1